export const version = "units/5.8.0";
//# sourceMappingURL=_version.js.map